import { useMutation } from "react-query";
import axios, { AxiosError } from "axios";

const UpdateEmployerODPLimitConfigApiService = async (
  request: any
): Promise<void> => {
  const url = "/odp_limits/employer/rules/";
  const { data } = await axios.put(url, request);
  return data;
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const useUpdateEmployerODPLimitConfigApiService = () =>
  useMutation<void, AxiosError, any>(UpdateEmployerODPLimitConfigApiService, {
    mutationKey: "UpdateEmployerODPLimitConfigApiService",
  });

export default useUpdateEmployerODPLimitConfigApiService;
